

export interface footerState {
        version: string, 
}

export const footerInitialState:footerState = {
          version: "0",
    }


export function deepCopyGraphThingyState(toCopy:footerState):footerState{
    return {
        version:toCopy.version,
    }
    
}